export default __webpack_public_path__ + "img/indonesia-flag.bdbcbb1d.svg";